import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import { Typography, Grid, Box } from '@mui/material';
import './levels.css';
import HeadingContainer from "../heading-container/HeadingContainer";

function LevelCard({ level, ageRange, description, index }) {
    // Alternate elegant colors for cards
    const colors = ['var(--primary)', 'var(--secondary)', 'var(--tertiary)', 'var(--quaternary)'];
    const accentColor = colors[index % colors.length];

    return (
        <Grid item xs={12} sm={6} md={6}>
            <Box className="levelCard hover-scale" sx={{ height: '100%', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '6px', backgroundColor: accentColor }}></div>
                <Typography variant="h5" sx={{ color: accentColor, fontWeight: 800, mb: 1, fontFamily: 'var(--font-heading)' }}>
                    {level}
                </Typography>
                {ageRange && (
                    <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 2, display: 'inline-block', backgroundColor: 'rgba(0,0,0,0.04)', padding: '4px 12px', borderRadius: '12px' }}>
                        Age: {ageRange}
                    </Typography>
                )}
                <Typography variant="body1" className="description" sx={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>
                    {description}
                </Typography>
            </Box>
        </Grid>
    );
}

function Levels() {
    const [levels, setLevels] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/levels`)
            .then(res => res.json())
            .then(data => {
                if (data && Array.isArray(data)) {
                    setLevels(data);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching levels:", err);
                setLoading(false);
            });
    }, []);

    return (
        <div className="levelsContainer">
            <HeadingContainer title="Academic Levels" />
            <div style={{ position: 'relative', padding: '60px 0', background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)' }}>
                <Container maxWidth="lg" className="contentContainer" style={{ position: 'relative', zIndex: 10 }}>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                            <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                        </div>
                    ) : (
                        <Grid container spacing={4} justifyContent="center">
                            {levels.map((levelItem, index) => (
                                <LevelCard
                                    key={levelItem._id || index}
                                    index={index}
                                    level={levelItem.title || levelItem.level} // Check both for backward compat
                                    ageRange={levelItem.ageRange}
                                    description={levelItem.description}
                                />
                            ))}
                        </Grid>
                    )}
                </Container>
            </div>
        </div>
    );
}

export default Levels;
